const PHRASES = [
  "Mobile Brake Replacement",
  "We Come To You",
  "Middlesex County, MA",
  "Southern New Hampshire",
  "Warranty-Backed Repairs",
];

export function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-edge bg-slate2 py-4"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap font-display text-2xl font-bold uppercase tracking-tight text-slate-600">
                  {p}
                </span>
                <span className="mx-6 h-2 w-2 rotate-45 bg-crimson" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
